// React libs
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Field, Form, FormikProps, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
// Components
import Button from '../../../../../../Core/Components/UiKit/Button/Button';
import FaIcon from '../../../../../../Core/Components/UiKit/Icon/FaIcon/FaIcon';
import TextField from '../../../../../../Core/Components/UiKit/Form/TextField/TextField';
// Type
import * as Types from './ForgotPasswordForm.type';
// Utils
import {
  isDisabled,
  getFormPropTypes,
} from '../../../../../../Core/Utils/FormUtils';
// Common
import Common from '../../../../../Resources/Common';

const ForgotPasswordForm: FC<Types.IProps> = ({
  defaultValues,
  miscFunctions,
  onFormSubmit,
  validationSchema,
}) => (
  <Formik
    initialValues={defaultValues}
    onSubmit={onFormSubmit}
    validationSchema={validationSchema}
  >
    {(formikProps: FormikProps<any>) => (
      <ForgotPasswordFormikForm
        {...formikProps}
        miscFunctions={miscFunctions}
      />
    )}
  </Formik>
);

ForgotPasswordForm.propTypes = getFormPropTypes();

export default ForgotPasswordForm;

const ForgotPasswordFormikForm = ({
  errors,
  isSubmitting,
  touched,
}: FormikProps<any> & any) => {
  // Variables
  const { t } = useTranslation(['common', 'auth']);

  return (
    <Form data-testid='forgot-password-form'>
      <Field
        id='email'
        name='email'
        component={TextField}
        label={t('auth:forgotPassword.form.email.label')}
        color='secondary'
      />
      <div className='flex items-center justify-end text-2xs'>
        <Link to={`/${Common.Routes.routeLogin}`}>
          {t('auth:forgotPassword.misc.backLogin')}
        </Link>
      </div>
      <div className='flex items-center justify-center'>
        <Button
          type='submit'
          variant='text'
          size='large'
          disabled={isDisabled(errors, isSubmitting, touched)}
          startIcon={
            isSubmitting ? <FaIcon name='spinner' className='fa-spin' /> : null
          }
        >
          {isSubmitting
            ? t('auth:forgotPassword.form.submit.label.submitting')
            : t('auth:forgotPassword.form.submit.label.normal')}
        </Button>
      </div>
    </Form>
  );
};
